module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6916af8b3aa2a83574676b63a0398876.png";